// store.ts

import { Action, AnyAction, Reducer, ThunkAction, combineReducers, configureStore, createAction } from '@reduxjs/toolkit';

import actionsReducer from '../slices/actionsSlice'; // Import the actions slice
import languageReducer from '../slices/languageSlice';
import notificationReducer from '../slices/notificationSlice';
import rtuReducer from '../slices/rtuSlice';
import thunk from 'redux-thunk';
import userReducer from '../slices/userSlice';

const appReducer = combineReducers({
  notifications: notificationReducer,
  rtu: rtuReducer,
  language: languageReducer,
  user: userReducer,
  actions: actionsReducer,  // Add the actions slice to your store
});

// Dispatched when the signed-in identity changes or ends (see services/sessionIdentity).
export const resetUserScopedState = createAction('session/resetUserScopedState');

// Everything except the UI language belongs to the previous identity and is dropped.
const rootReducer: Reducer<ReturnType<typeof appReducer>, AnyAction> = (state, action) =>
  appReducer(
    resetUserScopedState.match(action) ? ({ language: state?.language } as typeof state) : state,
    action
  );

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
});

if (typeof window !== 'undefined' && (window as any).Cypress) {
  (window as any).__DMS_STORE__ = store;
}

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
